function DibsBuyerLayoutStoreProvider() {
    let _setStore;

    const promise = new Promise((resolve) => {
        _setStore = (store) => {
            resolve(store);
            return store;
        };
    });

    return {
        getStore: () => promise.then(store => store),
        setStore: store => _setStore(store),
    };
}

export default DibsBuyerLayoutStoreProvider();



// WEBPACK FOOTER //
// ./assets/js/global/DibsBuyerLayoutStoreProvider.es.js